(() => {
  if (customElements.get('hydros-catalog-product')) return;
  class HydrosCatalogProduct extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      let prelaunchVariants = [];
      try { prelaunchVariants = JSON.parse(this.dataset.prelaunchVariants || '[]'); } catch (_) { /* Native product data remains authoritative. */ }
      this.querySelectorAll('[data-colour],[data-part]').forEach(input => {
        const entry = prelaunchVariants.find(variant => variant.title === input.value);
        if (!input.dataset.variantId && entry) input.dataset.variantId = entry.id;
      });
      const initialVariant = this.querySelector('[data-alert-variant]');
      if (initialVariant && !initialVariant.value && prelaunchVariants[0]) initialVariant.value = prelaunchVariants[0].id;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.track = this.querySelector('.hc-gallery__track');
      this.slides = [...this.querySelectorAll('.hc-gallery__slide')];
      this.index = 0;
      this.zoomDialog = this.querySelector('[data-gallery-dialog]');
      this.inputIsKeyboard = false;
      this.addEventListener('pointerdown', () => { this.inputIsKeyboard = false; }, { signal: this.abort.signal });
      this.addEventListener('keydown', (event) => {
        this.inputIsKeyboard = true;
        if (this.zoomDialog?.open && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          this.go((this.index + (event.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length, true);
        }
      }, { signal: this.abort.signal });
      this.querySelector('[data-gallery-zoom]')?.removeAttribute('hidden');
      this.zoomDialog?.addEventListener('click', (event) => {
        if (event.target === this.zoomDialog) this.zoomDialog.close();
      }, { signal: this.abort.signal });
      this.zoomDialog?.addEventListener('close', () => {
        this.setDetailZoom(false);
        this.querySelector('[data-gallery-zoom]')?.focus({ preventScroll: true });
      }, { signal: this.abort.signal });
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-index]');
        const arrow = event.target.closest('[data-gallery-direction]');
        const instant = event.detail === 0 || this.inputIsKeyboard;
        if (thumb) this.go(Number(thumb.dataset.galleryIndex), instant);
        if (arrow) this.go((this.index + Number(arrow.dataset.galleryDirection) + this.slides.length) % this.slides.length, instant);
        if (event.target.closest('[data-gallery-zoom],.hc-gallery__slide')) this.openZoom(instant);
        if (event.target.closest('[data-zoom-close]')) this.zoomDialog.close();
        if (event.target.closest('[data-zoom-detail]')) this.setDetailZoom(!this.zoomDetail);
      }, { signal: this.abort.signal });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-colour]')) {
          this.querySelector('[data-colour-name]').textContent = event.target.value;
          this.go(Number(event.target.dataset.imageIndex), this.inputIsKeyboard);
          const fallback = this.querySelector('.hj--kids .hj-fallback');
          const source = this.slides[Number(event.target.dataset.imageIndex)]?.querySelector('img');
          if (fallback && source) { fallback.src = source.src; fallback.alt = source.alt; }
        }
        if (event.target.matches('[data-part]')) {
          const pack = event.target.value.startsWith('Pack');
          const subscription = this.querySelector('[data-formula][value="Abonnement"]');
          // A full set is not renewed on one shared cadence by default.
          subscription.disabled = pack;
          if (pack && subscription.checked) this.querySelector('[data-formula][value="Achat unique"]').checked = true;
          subscription.closest('label').classList.toggle('hc-option--disabled', pack);
        }
        this.updateSelection();
      }, { signal: this.abort.signal });
      this.track?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, { signal: this.abort.signal });
      this.track?.addEventListener('scroll', () => {
        const width = this.track.clientWidth;
        if (!width) return;
        this.index = Math.round(this.track.scrollLeft / width);
        this.querySelector('[data-gallery-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
        this.querySelectorAll('[data-gallery-index]').forEach((button, index) => {
          button.classList.toggle('is-active', index === this.index);
          if (index === this.index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
        });
        if (this.zoomDialog?.open) this.updateZoom();
      }, { signal: this.abort.signal, passive: true });
      this.steps = [...this.querySelectorAll('[data-story-step]')];
      this.storyLayers = [...this.querySelectorAll('[data-story-layer]')];
      this.storyLayer = 0;
      this.storyActive = -1;
      this.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open && !this.reducedMotion.matches && !this.inputIsKeyboard) {
            details.querySelector('div')?.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'cubic-bezier(.23,1,.32,1)' });
          }
        }, { signal: this.abort.signal });
      });
      this.alertForm = this.querySelector('.hc-stock form');
      if (this.dataset.providerEnabled === 'true') {
        this.alertForm?.addEventListener('submit', (event) => { event.preventDefault(); this.requestAlert(); }, { signal: this.abort.signal });
      }
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.renderStory(); this.frame = 0; });
      };
      window.addEventListener('scroll', this.onScroll, { signal: this.abort.signal, passive: true });
      window.addEventListener('resize', this.onScroll, { signal: this.abort.signal, passive: true });
      this.reducedMotion.addEventListener('change', () => { this.renderStory(); }, { signal: this.abort.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => { this.querySelector('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 });
        this.observer.observe(this.querySelector('.hydros-pdp__hero'));
      }
      const pack = this.querySelector('[data-part]:checked');
      if (pack) pack.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateSelection(); this.renderStory();
    }
    go(index, instant = false) {
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      if (this.zoomDialog?.open) instant = true;
      this.track?.scrollTo({ left: index * this.track.clientWidth, behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth' });
      if (this.zoomDialog?.open) { this.index = index; this.updateZoom(); }
    }
    openZoom(instant) {
      if (!this.zoomDialog || this.zoomDialog.open) return;
      this.updateZoom();
      this.zoomDialog.showModal();
      if (!instant && !this.reducedMotion.matches) {
        this.zoomDialog.querySelector('.hc-zoom__panel').animate([{ opacity: 0, transform: 'scale(.97)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 180, easing: 'cubic-bezier(.23,1,.32,1)' });
      }
    }
    updateZoom() {
      const source = this.slides[this.index]?.querySelector('img');
      if (!source) return;
      const image = this.querySelector('[data-zoom-image]');
      const nextSource = source.currentSrc || source.src;
      if (image.getAttribute('src') !== nextSource) this.setDetailZoom(false);
      image.src = nextSource;
      image.alt = source.alt;
      this.querySelector('[data-zoom-caption]').textContent = `${source.alt} · ${this.index + 1} / ${this.slides.length}`;
    }
    setDetailZoom(active) {
      this.zoomDetail = active;
      const viewport = this.querySelector('[data-zoom-viewport]');
      const button = this.querySelector('[data-zoom-detail]');
      if (!viewport || !button) return;
      viewport.classList.toggle('is-detail', active);
      viewport.setAttribute('aria-label', active ? 'Photo agrandie, faites glisser pour examiner les détails' : 'Photo du produit');
      button.setAttribute('aria-pressed', String(active));
      button.textContent = active ? 'Vue complète' : 'Voir les détails';
      viewport.scrollTo({ left: active ? (viewport.scrollWidth - viewport.clientWidth) / 2 : 0, top: active ? (viewport.scrollHeight - viewport.clientHeight) / 2 : 0, behavior: 'instant' });
    }
    updateSelection() {
      const colour = this.querySelector('[data-colour]:checked')?.value;
      const formula = this.querySelector('[data-formula]:checked')?.value;
      const part = this.querySelector('[data-part]:checked')?.value;
      const subscription = formula === 'Abonnement';
      const panel = this.querySelector('[data-subscription]');
      if (panel) {
        const opening = panel.hidden && subscription;
        panel.hidden = !subscription;
        if (opening && !this.reducedMotion.matches && !this.inputIsKeyboard) {
          panel.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'cubic-bezier(.23,1,.32,1)' });
        }
      }
      const schedule = subscription ? this.querySelector('[data-schedule]')?.value : '';
      const selection = [colour, part, formula, schedule].filter(Boolean).join(' · ');
      const selectionField = this.querySelector('[data-alert-selection]');
      if (selectionField) selectionField.value = selection;
      const variantField = this.querySelector('[data-alert-variant]');
      const selectedVariant = this.querySelector('[data-colour]:checked')?.dataset.variantId || this.querySelector('[data-part]:checked')?.dataset.variantId;
      if (variantField && selectedVariant) variantField.value = selectedVariant;
      const summary = this.querySelector('[data-alert-summary]');
      if (summary) summary.textContent = this.querySelector('h1').textContent + (selection ? ' · ' + selection : '');
    }
    async requestAlert() {
      if (this.alertPending || !this.alertForm.reportValidity()) return;
      const variant = this.querySelector('[data-alert-variant]')?.value;
      const result = this.querySelector('[data-alert-result]');
      if (!/^\d+$/.test(variant || '')) {
        result.hidden = false; result.textContent = 'Sélectionnez votre produit avant de demander une alerte.'; return;
      }
      const email = this.alertForm.querySelector('[type="email"]').value.trim();
      const button = this.alertForm.querySelector('[type="submit"]');
      const originalLabel = button.textContent;
      this.alertPending = true; button.disabled = true; button.textContent = 'Envoi…';
      this.alertForm.setAttribute('aria-busy', 'true'); result.hidden = true;
      this.alertRequest = new AbortController();
      const timeout = setTimeout(() => this.alertRequest.abort(), 12000);
      try {
        // Exact public provider contract inspected in its installed theme extension.
        // HTTPS replaces the extension's HTTP URL; the name field is a request label, never customer identity.
        const response = await fetch('https://backinstock.fadecommerce.com/api/email-subscribe', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: this.alertRequest.signal,
          body: JSON.stringify({ shopify_domain: Shopify.shop, name: `Alerte HYDROS · ${this.querySelector('h1').textContent} · ${this.querySelector('[data-alert-selection]')?.value || ''}`, email, variant_id: variant })
        });
        if (!response.ok) throw new Error('provider_response');
        const data = await response.json();
        if (!data.status) throw new Error('provider_registration');
        result.textContent = 'Votre alerte est enregistrée. Nous vous préviendrons dès que cette référence sera disponible.';
        result.className = 'hc-success'; result.hidden = false;
      } catch (_) {
        result.textContent = 'L’alerte n’a pas pu être enregistrée. Réessayez dans un instant ou contactez HYDROS.';
        result.className = 'hc-alert-error'; result.hidden = false;
      } finally {
        clearTimeout(timeout); this.alertPending = false; button.disabled = false; button.textContent = originalLabel;
        this.alertForm.removeAttribute('aria-busy');
      }
    }
    renderStory() {
      if (!this.steps.length) return;
      const scene = this.querySelector('.hc-story').getBoundingClientRect();
      if (scene.bottom < 0 || scene.top > innerHeight) return;
      const target = innerHeight * .62;
      let active = 0, distance = Infinity;
      this.steps.forEach((step, index) => {
        const rect = step.getBoundingClientRect();
        const current = Math.abs(rect.top + rect.height / 2 - target);
        if (current < distance) { distance = current; active = index; }
      });
      if (active !== this.storyActive) {
        this.storyActive = active;
        this.steps.forEach((step, index) => step.classList.toggle('is-active', index === active));
        this.querySelector('[data-story-counter]').textContent = `0${active + 1} / 03`;
        const label = this.steps[active].querySelector('h3').textContent;
        this.querySelector('[data-story-label]').textContent = label;
        this.switchStoryImage(this.steps[active].dataset.storySrc, label);
      }
      const image = this.querySelector('[data-story-image]');
      if (!this.reducedMotion.matches) {
        const first = this.steps[0].getBoundingClientRect();
        const last = this.steps[this.steps.length - 1].getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (target - first.top) / (last.bottom - first.top)));
        image.style.transform = `translateY(${(progress - .5) * -4}%) scale(${1 + Math.sin(progress * Math.PI) * .08})`;
      } else image.style.transform = 'none';
    }
    switchStoryImage(src, label) {
      const token = this.storyImageToken = (this.storyImageToken || 0) + 1;
      const current = this.storyLayers[this.storyLayer];
      if (!src || !current || current.getAttribute('src') === src) return;
      const nextIndex = 1 - this.storyLayer, next = this.storyLayers[nextIndex];
      next.src = src; next.alt = label;
      next.decode().then(() => {
        if (!this.isConnected || token !== this.storyImageToken) return;
        const duration = this.reducedMotion.matches || this.inputIsKeyboard ? '0ms' : '220ms';
        next.style.transitionDuration = duration; current.style.transitionDuration = duration;
        next.style.opacity = '1'; current.style.opacity = '0';
        next.removeAttribute('aria-hidden'); current.setAttribute('aria-hidden', 'true');
        this.storyLayer = nextIndex;
      }).catch(() => { /* Keep the current photograph visible if decoding fails. */ });
    }
    disconnectedCallback() { this.abort?.abort(); this.alertRequest?.abort(); this.observer?.disconnect(); this.storyImageToken = (this.storyImageToken || 0) + 1; this.zoomDialog?.close(); cancelAnimationFrame(this.frame); }
  }
  customElements.define('hydros-catalog-product', HydrosCatalogProduct);
})();
